import { useStore } from 'effector-react';
import React from 'react';
import dayjs from 'dayjs';
import { styled } from 'linaria/react';
import { createForm, useForm } from 'effector-forms';
import { FormField, TextInput, Textarea, Checkbox, toaster } from 'evergreen-ui';

import { routes } from 'src/routes';
import { history } from 'src/history';
import { isUserActive$, user$ } from 'src/store/user.store';
import { Block } from 'src/ui/atoms/block';
import { Page } from 'src/ui/templates/page';
import { dateToInputValue } from 'src/common/date';
import { createGroupFx } from 'src/store/group.store';

const Form = styled.form`
	display: grid;
	grid-template-columns: 1fr;
	grid-row-gap: 16px;
`;
const ButtonContainer = styled.div`
	display: flex;
	justify-content: flex-end;
`;

const Button = styled.button` 
		
            height: 40px;
            width: 80%;
            margin: 40px auto;
				text-align: center;
				display: flex;
				justify-content: center;
                 background: #087587;
                color: #fff;
                transition: all .4s;
                border: none;
                border-radius: 30px;
                padding: 12px;
                font-size: 16;
                outline: none;
                max-width: 300;
                font-family: 'Montserrat',sans-serif;
                font-weight: 300;
                
`;

const createGroupForm = createForm({
	fields: {
		caption: {
			init: '',
		},
		description: {
			init: '',
		},
		private: {
			init: false,
		},
		key: {
			init: null as string | null,
		},
		event_date: {
			init: dayjs().toISOString(),
		},
		distribution_date: {
			init: dayjs().toISOString(),
		},
	},
});

export const CreateGroupPage = () => {
	const form = useForm(createGroupForm);
	const isUserActive = useStore(isUserActive$);

	const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		if (!isUserActive) {
			toaster.danger('To create a box you need to fill out a profile and add more than 5 interests')
			return;
		}

		const { id } = await createGroupFx(form.values);
		history.push(routes.root.home.group.url(id));
	};

	return (
		<Page title={'Create box'}>
			<Block>
				<Form onSubmit={handleSubmit}>
					<FormField label={'Title'} className={'inputstyle'}>
						<TextInput
							required
							value={form.fields.caption.value}
							onChange={(e: React.ChangeEvent<HTMLInputElement>) => form.fields.caption.onChange(e.target.value)}
							width={'100%'}

						/>
					</FormField>
					<FormField label={'Description'} className={'inputstyle'}>
						<Textarea
							value={form.fields.description.value}
							onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => form.fields.description.onChange(e.target.value)}
                            
						/>
					</FormField>
					<Checkbox
						label={'Private'}
						checked={form.fields.private.value}
						onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
							if (e.target.checked) {
								form.fields.key.onChange('');
							} else {
								form.fields.key.onChange(null);
							}

							form.fields.private.onChange(e.target.checked);
						}}
						style={{ margin: 0 }}
					/>
					{form.values.private && (
						<FormField label={'Password'} className={'inputstyle'}>
							<TextInput
								type={'password'}
								width={'100%'}
                                
							/>
						</FormField>
					)}
					<FormField label={'Event date'} className={'inputstyle'}>
						<TextInput
							required
							value={dayjs(form.values.event_date).format('YYYY-MM-DD')}
							onChange={(e: React.ChangeEvent<HTMLInputElement>) => form.fields.event_date.onChange(dateToInputValue(e.target.value))}
							type={'date'}
							width={'100%'}
                            
						/>
					</FormField>
					<FormField label={'Distribution date'} className={'inputstyle'}>
						<TextInput
							required
							value={dayjs(form.values.distribution_date).format('YYYY-MM-DD')}
							onChange={(e: React.ChangeEvent<HTMLInputElement>) => form.fields.distribution_date.onChange(dateToInputValue(e.target.value))}
							type={'date'}
							width={'100%'}
                            
						/>
					</FormField>
					<ButtonContainer>
						<Button>Create</Button>
					</ButtonContainer>
				</Form>
			</Block>
		</Page>
	);
};
